// extracted by mini-css-extract-plugin
module.exports = {"Errors":"UserRequestDataForm_Errors__p27u2","Bold":"UserRequestDataForm_Bold__fq4sQ"};